import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse} from '@angular/common/http';
import {throwError} from 'rxjs';
import {isTrialExpired} from '../config';

@Injectable()
export class TrialExpirationInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (isTrialExpired()) {
      return throwError(() => new HttpErrorResponse({status: 403, statusText: 'Trial Expired'}));
    }
    return next.handle(req);
  }
}
